export const leadUserSchema = {
	schema: {
		title: 'Lead user schema',
		description: 'create a Lead schema',
		version: 1,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			name: {
				type: 'string',
			},
			phone: {
				type: 'string',
				maxLength: 250,
			},
			variable_contractor_type_c: {
				type: 'string',
			},
			source_c: {
				type: 'string',
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
			lastmodifieddate: { type: ['string', 'null'] },
			points_banked: {
				type: ['number', 'null'],
			},
			membershipno_c: {
				type: 'string',
			},
			status: {
				type: ['string', 'null'],
			},
			app_id_c: {
				type: 'string',
			},
			nameofthefirm_c: {
				type: ['string', 'null'],
			},
		},
		required: [
			'id',
			'sfid',
			'name',
			'phone',
			'variable_contractor_type_c',
			'source_c',
			'createddate',
			'lastmodifieddate',
			'points_banked',
			'status',
			'app_id_c',
		],
	},
	migrationStrategies: {
		1: (oldDoc: Record<string, unknown>): Record<string, unknown> => ({
			...oldDoc,
			nameofthefirm_c: typeof oldDoc.nameofthefirm_c === 'string' ? oldDoc.nameofthefirm_c : null,
		}),
	},
};
